import { type FC, type PropsWithChildren } from 'react';
import TwoArrowsIcon from '@assets/img/icons/two-arrows.svg?react';
import { H2, StringSmall } from '@components/Typography/Typography';
import cn from 'classnames';

import css from './styles.module.scss';

interface SecondaryTimerProps extends PropsWithChildren {
  value: string;
  className?: string;
  variant?:
    | 'boost'
    | 'default'
    | 'goldenContract'
    | 'nextGoldenContract'
    | 'boostX5X10';
  withLightning?: boolean;
}

const SecondaryTimer: FC<SecondaryTimerProps> = ({
  value,
  className,
  variant = 'default',
  withLightning,
  children,
}) => {
  return (
    <div
      className={cn(css.secondary, className, withLightning && '!pr-[2rem]')}
      style={{
        background: ['goldenContract', 'nextGoldenContract'].includes(variant)
          ? 'var(--surface-60, #1D1F2599)'
          : '',
        border:
          variant == 'nextGoldenContract'
            ? '1px solid var(--border-40, #FFFFFF66)'
            : '',
      }}
    >
      {withLightning && (
        <TwoArrowsIcon className="w-6 h-6 shrink-0 absolute right-[8px] top-1/2 -translate-y-1/2" />
      )}
      <div className="sm-h:mr-1 sm-h:w-[65px] flex items-center justify-center">
        {variant === 'default' && (
          <H2 weight="medium" className="!text-white sm-h:!leading-none">
            {value}
          </H2>
        )}
        {variant === 'boost' && (
          <StringSmall
            weight="regular"
            className="!text-white !text-[0.875rem]"
          >
            {value}
          </StringSmall>
        )}
        {variant === 'boostX5X10' && (
          <StringSmall
            weight="regular"
            className="text-white/50 !text-[0.875rem]"
          >
            {value}
          </StringSmall>
        )}
        {['goldenContract', 'nextGoldenContract'].includes(variant) && (
          <StringSmall weight="bold" className="!text-white">
            {value}
          </StringSmall>
        )}
      </div>
      {children}
    </div>
  );
};

export { SecondaryTimer };
